import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { chatKeys } from '../../keys'
import chatService from '../services'

import type { components } from '@/schema'

type UpdateChatSettingsDto = components['schemas']['UpdateChatSettingsDto']

export function useQueryChatSettings() {
	return useQuery({
		queryKey: chatKeys.settings(),
		queryFn: () => chatService.getSettings(),
	})
}

export function useMutationUpdateChatSettings() {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (data: UpdateChatSettingsDto) =>
			chatService.updateSettings(data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: chatKeys.settings() })
			toast.success('บันทึกการตั้งค่าเรียบร้อยแล้ว')
		},
		onError: () => {
			toast.error('บันทึกการตั้งค่าไม่สำเร็จ กรุณาลองใหม่อีกครั้ง')
		},
	})
}
